import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { ReportId, CompactStatBatchResponse, StatBatchResponse } from '@business/entities/reports';
import { ReportAPI } from '@business/api/report_api';
import { FCFormDataType } from '@modules/statistics/StatCollection/FormFields/types';
import { StatReportFormData } from '@modules/statistics/StatCollection/StatCollection/AddEditStatFormTab/ViewStatCollectionFormPage/ViewStatCollectionFormPage';
import { showConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';

export class BatchBloc extends BaseBloc {
  private readonly batchRepo = new Repository<CompactStatBatchResponse | StatBatchResponse>({
    getItemId: item => item.id,
  });

  readonly items$ = this.batchRepo.items$;
  readonly selectItem = this.batchRepo.selectItem;

  onReset() {
    this.batchRepo.reset();
  }

  fetchItems = () => {
    return ReportAPI.fetchBatches().pipe(this.batchRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_stat_error') }));
  };

  fetchItem = (id: ReportId) => {
    return ReportAPI.fetchBatch(id).pipe(
      this.batchRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_stat_error') }),
    );
  };

  saveStatReportForm = (id: string, data: StatReportFormData, fields: FCFormDataType[], isPublic = false) => {
    return ReportAPI.saveStatReportForm(id, data, fields, isPublic).pipe(
      handleMessage({
        type: requestMessage('update_stat'),
      }),
    );
  };

  resendEmail = (id: string) => {
    return ReportAPI.resendEmail(id).pipe(
      handleMessage({
        type: requestMessage('stat_form_resend_all'),
      }),
    );
  };

  resendEmailToAll = (id: string) => {
    return showConfirmation('Resend Email', 'Do you really want to Resend email to all the users?').pipe(
      switchMap(() => ReportAPI.resendEmailToAll(id)),
      handleMessage({
        type: requestMessage('stat_form_resend_all'),
      }),
    );
  };
}
